import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopNav from "../../components/navigation/TopNav";

import StandardScreen, { ScreenContent } from "../../components/layout/StandardScreen";
import Stack from "../../components/layout/Stack";
import Card from "../../components/ui/Card";
import Button from "../../components/ui/Button";

const narrowShellStyle = {
  width: "100%",
  maxWidth: "720px",
  margin: "0 auto",
};

export default function GodDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <StandardScreen
      topNav={<TopNav title={t("god_dashboard.title")} mode="main" />}
    >
      <ScreenContent>
        <div style={narrowShellStyle}>
          <Stack gap="4">
            <Card title={t("god_dashboard.title")}>
              <p style={{ margin: 0 }}>
                {t("god_dashboard.subtitle")}
              </p>
            </Card>

            <Card>
              <Stack gap="3">
                <h2 style={{ margin: 0, fontSize: "1.2rem", fontWeight: 700 }}>
                  {t("god_dashboard.frequently_used.title")}
                </h2>

                <p style={{ margin: 0 }}>
                  {t("god_dashboard.frequently_used.subtitle")}
                </p>

                <Stack gap="2">
                  
                  <Button fullWidth onClick={() => navigate("/god/create-vendor-and-admin")}>{t("god_dashboard.frequently_used.label1")}</Button>

                  <Button fullWidth onClick={() => navigate("/god/vendor-detail")}>{t("god_dashboard.frequently_used.label2")} </Button>

                </Stack>
              </Stack>
            </Card>
          </Stack>
        </div>
      </ScreenContent>
    </StandardScreen>
  );
}